module.exports = __webpack_public_path__ + "static/media/algorithm.f0fd216f.png";